import { useForm } from 'react-hook-form';
import { useTranslation } from 'react-i18next';
import useFormHook from '@shared/hooks/useFormHook';
import { useFormGroup } from '../hooks/useFormGroup';
import { yupResolver } from '@hookform/resolvers/yup';

export default function FormGroup({ userGroup, onClose, selectedData, fetchData }) {
  const { t } = useTranslation();
  const { modalRef } = useFormHook({}, onClose);
  const {
    serverMessage,
    onSubmit,
    validationSchema
  } = useFormGroup(userGroup, selectedData, onClose, fetchData, t);

  const { register, handleSubmit, formState: { errors } } = useForm({
    resolver: yupResolver(validationSchema),
    defaultValues: userGroup
      ? {
        name: userGroup.name,
        ldapGroupId: userGroup.ldapGroupId,
      }
      : { name: '', ldapGroupId: '' },
  });

  return (
    <div className='modal show' tabIndex="-1">
      <div className="form-wrapper top-20 width-50">
        <form className="form" ref={modalRef} onSubmit={handleSubmit(onSubmit)}>
          <h2 className='title'>{userGroup ? t('users.table.headers.editGroup') : t('users.table.headers.addGroup')}</h2>
          <div className="form-input-wrapper">
            {serverMessage && <div className="error-message">{serverMessage}</div>}
            <div className='form-group'>
              <span className="span-bold">{t('users.table.search.options.groupName')} <span className="required">*</span></span>
              <input
                type="text"
                className={`form-control ${errors.name ? 'is-invalid' : ''}`}
                {...register('name')}
              />
              {errors.name && (
                <div className="invalid-feedback">
                  {errors.name.message}
                </div>
              )}
            </div>
          </div>

          <div className="form-input-wrapper">
            <div className='form-group'>
              <span className="span-bold">{t('users.table.search.options.LDAP')} <span className="required">*</span></span>
              <input
                type="number"
                className={`form-control ${errors.ldapGroupId ? 'is-invalid' : ''}`}
                {...register('ldapGroupId')}
              />
              {errors.ldapGroupId && (
                <div className="invalid-feedback">
                  {errors.ldapGroupId.message}
                </div>
              )}
            </div>
          </div>
          <div className="form-controls-container padding-20">
            <button type="submit" className="form-btn btn-blue">
              {t('common.save')}
            </button>
            <button
              type="button"
              className="form-btn btn-red"
              onClick={onClose}
            >
              {t('common.cancel')}
            </button>
          </div>
        </form>
      </div>
    </div>
  );
}